import {
	Alert,
	Button,
	Chip,
	Link,
	Skeleton,
	Stack,
	Typography,
} from '@mui/material';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import { formatBillingDate } from '../constants';
import { SectionCard, SectionHeader } from '../components/SettingsShell';
import { trialDaysLeft, trialDaysLeftLabel } from '../../../Shared/trial';

const TrialBillingSection = ({
	subscriptionLoading,
	trialEndsAt,
	onChoosePlan,
}) => {
	const daysLeft = trialDaysLeft(trialEndsAt);
	const endLabel = formatBillingDate(trialEndsAt);
	const remaining = trialDaysLeftLabel(daysLeft);

	return (
		<SectionCard id="billing">
			<SectionHeader
				icon={CreditCardOutlinedIcon}
				title="Subscription & billing"
				description="You're on a 30-day free trial. Upgrade anytime — no charge until you pick a plan."
				titleAdornment={
					subscriptionLoading ? null : (
						<Chip
							label="Free trial"
							size="small"
							color="warning"
							variant="outlined"
						/>
					)
				}
			/>

			{subscriptionLoading ? (
				<Stack spacing={2}>
					<Skeleton variant="text" width="80%" />
					<Skeleton variant="rounded" height={72} />
				</Stack>
			) : (
				<Stack spacing={2.5}>
					<Alert severity="info">
						No credit card on file. Upgrade anytime and you&apos;ll be billed on
						the 1st of the month, prorated if you start any other day.
					</Alert>

					<Stack spacing={0.75}>
						<Typography variant="body1" fontWeight={600}>
							Free trial{remaining ? ` — ${remaining}` : ''}
						</Typography>
						{endLabel ? (
							<Typography variant="body2" color="text.secondary">
								Trial ends {endLabel}
							</Typography>
						) : null}
						<Typography variant="body2" color="text.secondary">
							Includes the full Basic product plus bid text alerts, scheduling,
							analytics, and invoice late fees. Time tracking, extra users, and
							location services stay on Pro.
						</Typography>
					</Stack>

					<Typography variant="body2" color="text.secondary">
						Compare Basic and Pro on our{' '}
						<Link href="/pricing" target="_blank" rel="noopener">
							pricing page
						</Link>
						. Features you used in the trial that aren&apos;t on Basic stay only
						if you choose Pro.
					</Typography>

					<Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
						<Button
							variant="contained"
							color="warning"
							onClick={onChoosePlan}
							sx={{ width: { xs: '100%', sm: 'auto' } }}
						>
							Upgrade
						</Button>
					</Stack>
				</Stack>
			)}
		</SectionCard>
	);
};

export default TrialBillingSection;
